import { defineMessages } from 'react-intl';

export default defineMessages({
  hours: {
    id: 'cancellationPolicy.hours',
    defaultMessage: '{count, plural, one {1 hour} other {{count} hours}}',
  },
  startRowWithoutDuration: {
    id: 'cancellationPolicy.startRowWithoutDuration',
    defaultMessage: 'Cancelled experiences are eligible for a {refund} refund.',
  },
  startRow: {
    id: 'cancellationPolicy.startRow',
    defaultMessage:
      'Any experience cancellation that is {moreThanDuration} or more before the start time of the experience, ' +
      'is eligible for a {refund} refund. Please note - all bookings have a percentage booking fee included ' +
      'which will not be refunded upon cancellation.',
  },
  middleRow: {
    id: 'cancellationPolicy.middleRow',
    defaultMessage:
      'Cancellations less than {lessThanDuration} but {moreThanDuration} or more before the start time ' +
      'of the experience, are eligible for a {refund} refund.',
  },
  endRow: {
    id: 'cancellationPolicy.endRow',
    defaultMessage: 'Experiences cancelled less than {lessThanDuration} before the start time will be charged in full.',
  },
  endRowWithRefund: {
    id: 'cancellationPolicy.endRowWithRefund',
    defaultMessage:
      'Experiences cancelled less than {lessThanDuration} before the start time are eligible for a {refund} refund.',
  },
});
